import { render, staticRenderFns } from "./BaseAppModal.vue?vue&type=template&id=44688278&scoped=true&"
import script from "./BaseAppModal.vue?vue&type=script&lang=ts&"
export * from "./BaseAppModal.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAppModal.vue?vue&type=style&index=0&id=44688278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44688278",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44688278')) {
      api.createRecord('44688278', component.options)
    } else {
      api.reload('44688278', component.options)
    }
    module.hot.accept("./BaseAppModal.vue?vue&type=template&id=44688278&scoped=true&", function () {
      api.rerender('44688278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/modal/BaseAppModal.vue"
export default component.exports